/* eslint-disable */
import './projects.scss';
// import { Fancybox, Carousel } from "@fancyapps/ui/src/Fancybox/Fancybox.js";
import { Fancybox } from "@fancyapps/ui";
import Swiper, { Navigation } from 'swiper';
export default (() => {
  const swiper = new Swiper('#projects-carousel', {
    // Optional parameters
    modules: [Navigation],
    direction: 'horizontal',
    dots: true,
    observer: true,
    observeParents: true,
    preventClicksPropagation: true,
    preventClicks: false,
    allowTouchMove: false,
    loop: false,
    // Navigation arrows
    navigation: {
      nextEl: '.js-projects-next',
      prevEl: '.js-projects-prev'
    },
    breakpoints: {
      320: {
        centerInsufficientSlides: false,
        slidesPerView: 1.5,
        spaceBetween: 17,
        allowTouchMove: true,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true
      },
      640: {
        loop: false,
        slidesPerView: 2.5,
        spaceBetween: 34,
        centeredSlides: true,
        centeredSlidesBounds: true
      }
    }
  });
  Fancybox.bind('[data-fancybox="gallery"]', {
    animated: false,
    showClass: false,
    hideClass: false,
    click: false,
    dragToClose: false,
    Image: {
      zoom: false
    },
    Toolbar: {
      display: [{
        id: "counter",
        position: "center"
      }, "close"]
    }
  });
});